import { Appointment } from "../../../pages/platform/components/Appointment";
import { AppointmentStatus } from "../../../utils/Enums";
import { EXPERT_EMAILS } from "./constants";

export const filterAppointmentsByRole = (
    role: keyof typeof EXPERT_EMAILS,
    appointments: Appointment[] = []
) => {
    const roleEmails = EXPERT_EMAILS[role];
    return appointments
        .filter(app => app.remainingMinutes <= -30)
        .filter(app => app.status === AppointmentStatus.Active)
        .filter(app => roleEmails.includes(app.expert_email));
};